import React from "react"
import { RaisedButton} from "material-ui"
import strings from "../../localization/strings"

interface IProps {
    //gigPoolItem: IGigPoolDocument
    onNewMessageClick(): void
}

const MessageCenterActions: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{padding: 15}}>
            <RaisedButton
                icon={<i className="fa-solid fa-comment-plus" style={{color: "white"}} />}
                data-intercom-target={"IP-Btn-compose-message"}
                label={strings.Compose_New_message}
                secondary
                onClick={props.onNewMessageClick}            
            />

            <div style={{display: "grid", gridTemplateColumns: "auto min-content min-content min-content"}}>
                <div style={{gridColumn: 1}}>
                </div>
                <div style={{gridColumn: 2, paddingRight: 10}}>
                </div>                     
                <div style={{gridColumn: 3, paddingRight: 10}}>
                </div>
                <div style={{gridColumn: 4 }}>
                </div>                                       
            </div>
        </div>
    )
}

export default MessageCenterActions